import { ProviderCard } from '@/modules/gpt-chats/components/aimodels/aimodel-card/aimodel-card';
import { IProvider } from '@/modules/gpt-chats/types/aimodel.service.type';

interface ProviderListProps {
  providerList: IProvider[];
  servicePlatform: string;
}

import { useTranslation } from 'react-i18next';

export const AiModelsList = ({ servicePlatform, providerList }: ProviderListProps) => {
  const { t } = useTranslation();
  const sortedProviderList = [...providerList].sort((a, b) => Number(a.Order) - Number(b.Order));

  const modelsGrid = (providers: IProvider[]) => {
    return (
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {providers.map((provider) => (
          <ProviderCard key={provider.Provider} {...provider} />
        ))}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-5">
      <p className="border-b-1 border-gray-150 flex w-[100%] border-b pb-2 text-base font-normal text-low-emphasis">
        {servicePlatform}
      </p>
      {providerList.length ? (
        modelsGrid(sortedProviderList)
      ) : (
        <p className="my-4 text-center text-sm text-gray-500">{t('NO_RESULTS')}</p>
      )}
    </div>
  );
};
